import index from '@/store/index'

const locationUtil = {
  defaultCityName: '兰州市',
  defaultCityCode: '620100',
  defaultLocation: '103.848068,36.052349',
  getLocation: function () {
    return new Promise(function (resolve, reject) {
      let result = {};
      if (window.position) {
        result.location = window.position
        result.positionState = 1;
        result.msg = '获取定位成功';
        resolve(result);
      } else {
        if (window.isMiniProgram) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
              result.location = position.coords.longitude + ',' + position.coords.latitude;
              result.positionState = 1;
              result.msg = '获取定位成功';
              resolve(result);
            }, function (error) {
              console.log(error.message);
              let msg = '';
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  msg = '用户拒绝了定位请求'
                  break
                case error.POSITION_UNAVAILABLE:
                  msg = '位置信息不可用'
                  break
                case error.TIMEOUT:
                  msg = '获取位置信息超时'
                  break
                default:
                  msg = '获取定位信息失败'
                  break
              }
              result.positionState = 2;
              result.msg = msg;
              result.location = locationUtil.defaultLocation;
              result.cityCode = locationUtil.defaultCityCode;
              resolve(result);
            }, {
              timeout: 2000,
              maximumAge: 600000
            })
          } else {
            result.positionState = 3;
            result.msg = '暂不支持获取定位信息';
            result.location = locationUtil.defaultLocation;
            result.cityCode = locationUtil.defaultCityCode;
            resolve(result);
          }
        } else {
          try {
            lightAppJssdk.map.getLocation({
              success: function (data) {
                if (typeof data === 'string' && data.constructor == String) {
                  result.positionState = 2;
                  result.msg = data;
                  result.location = locationUtil.defaultLocation;
                  result.cityCode = locationUtil.defaultCityCode;
                  resolve(result);
                } else {
                  alert(JSON.stringify(data));
                  // var cityName = data.cityName;
                  // var region = data.region;
                  // var detailAddress = data.detailAddress;
                  const longitude = data.longitude;
                  const latitude = data.latitude;
                  result.location = longitude + ',' + latitude;
                  result.positionState = 1;
                  result.msg = '获取定位成功';
                  resolve(result);
                }
              },
              fail: function (data) {
                result.positionState = 3;
                result.msg = data;
                result.location = locationUtil.defaultLocation;
                result.cityCode = locationUtil.defaultCityCode;
                resolve(result);
              }
            });
          } catch (e) {
            result.positionState = 3;
            result.msg = '获取定位异常';
            result.location = locationUtil.defaultLocation;
            result.cityCode = locationUtil.defaultCityCode;
            resolve(result);
          }
        }
      }
    });
  },
}

export default locationUtil;
